var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLockXlWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.3332H36.8333V12.9998C36.8333 7.01984 31.98 2.1665 26 2.1665C20.02 2.1665 15.1667 7.01984 15.1667 12.9998V17.3332H13C10.6167 17.3332 8.66666 19.2832 8.66666 21.6665V43.3332C8.66666 45.7165 10.6167 47.6665 13 47.6665H39C41.3833 47.6665 43.3333 45.7165 43.3333 43.3332V21.6665C43.3333 19.2832 41.3833 17.3332 39 17.3332ZM26 36.8332C23.6167 36.8332 21.6667 34.8832 21.6667 32.4998C21.6667 30.1165 23.6167 28.1665 26 28.1665C28.3833 28.1665 30.3333 30.1165 30.3333 32.4998C30.3333 34.8832 28.3833 36.8332 26 36.8332ZM32.7167 17.3332H19.2833V12.9998C19.2833 9.29484 22.295 6.28317 26 6.28317C29.705 6.28317 32.7167 9.29484 32.7167 12.9998V17.3332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockXlWhite);
export default __webpack_public_path__ + "static/media/icon-lock-xl-white.47820da66ef2a33fdcabb5f9d4f1c953.svg";
export { ForwardRef as ReactComponent };